<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="editMode ? $t('eItemsReceivedEdit.EditTitle') : $t('eItemsReceivedEdit.AddTitle')"
            :width="'50%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:Label="$t('eItemsReceivedEdit.ItemCode')"
                        v-bind:ModelCode="item.itemCode"
                        v-bind:ModelDescription="item.description"
                        v-bind:Api="'ItemReceivedHeaders/InvetoryItems'"
                        v-bind:FieldCode="'itemCode'"
                        v-bind:FieldDescription="'description'"
                        v-bind:Fields="drugBaseFields"
                        v-bind:AuxFields="drugAuxFields"
                        v-bind:RefCode="'itemCode'"
                        v-bind:isRequired="true"
                        :isValid="isValid('itemCode')"
                        :SearchTitle="this.$tc('ePharmacyItemsReceived.Item', 2)"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"                
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:Label="$tc('ePharmacyItemsReceived.Location', 1)"
                        v-bind:ModelCode="item.code"
                        v-bind:ModelDescription="item.locationDescription"
                        v-bind:Api="'PharmacyLocations'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'name'"
                        v-bind:Fields="locationBaseFields"
                        v-bind:RefCode="'location'"
                        v-bind:isRequired="true"
                        :isValid="isValid('location')"
                        :SearchTitle="this.$tc('ePharmacyItemsReceived.Location', 1)"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"        
                    />
                </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="`${$t('ePharmacyItemsReceived.QtyReceived')} ${uomLabel}`"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'quantity'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-model="item.quantity"
                        @change="changeHandler"
                        v-bind:isRequired="true"
                        :isValid="isValid('quantity')"
                        v-bind:Id="'input_quantity'">                                     
                    </MdEdit>
                </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.UnitPrice')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'unitPrice'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'0.01'"
                        v-model="item.unitPrice"
                        @change="changeHandler"
                        v-bind:isRequired="true"
                        :isValid="isValid('unitPrice')"
                        v-bind:Id="'input_unitPrice'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row> 
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.LotNo')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'lotNo'"
                        v-model="item.lotNo"
                        v-bind:isRequired="true"
                        :isValid="isValid('lotNo')"
                        v-bind:Id="'input_lotNo'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.ExpirationDate')"
                        v-bind:TypeProp="'date'" 
                        v-bind:Name="'expirationDate'"
                        v-model="item.expirationDate"
                        v-bind:Min="'1900-01-01'"
                        v-bind:Max="'2200-12-31'"
                        v-bind:isRequired="true"
                        :isValid="isValid('expirationDate')"
                        v-bind:Id="'input_expirationDate'">                                     
                    </MdEdit>
                </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.Total')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'itemTotal'"
                        v-model="item.itemTotal"
                        v-bind:isReadOnly='true'
                        v-bind:Id="'input_itemTotal'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('ePharmacyItemsReceived.MinOrder')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'minOrder'"
                        v-model="item.minOrder"
                        v-bind:isReadOnly='true'
                        v-bind:Id="'input_minOrder'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
          
        </BaseModal>
    </div>
</template>

<script>
import Utils from "@/common/utils";
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'eItemsReceivedEditDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        value: Object,
        visible: {
            type: Boolean,
            default: false
        },
        drugBaseFields: Array,
        drugAuxFields: Array,
        locationBaseFields: Array
    },

    data() {
        const defaultValue = {
            batchNo: null,
            description: null,
            expirationDate: null,
            itemCode: null,
            itemNo: null,
            itemTotal: null,
            location: null,
            locationDescription:null,
            lotNo: null,
            minOrder: null,
            quantity: null,
            unitPrice: null
        }
        
        return {
            modalId: 'itemReceivedDialogId',
            refresh: false,
            item: this.value ? JSON.parse(JSON.stringify(this.value)) : JSON.parse(JSON.stringify(defaultValue)),
            defaultValue: defaultValue,            
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                //this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },

        value(newVal) {
            if (newVal) {
                this.item = JSON.parse(JSON.stringify(newVal));
            } else {
                this.item = JSON.parse(JSON.stringify(this.defaultValue));
            }
        }
    },

    computed: {
        okDisabled() {
            return !this.validate();
        },

        editMode() {
            return this.item !== null && this.item.itemNo !== null && this.item.itemNo !== undefined && this.item.itemNo > 0
        },

        uomLabel() {
            return this.item.uom ? `(${this.item.uom})` : '';
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
        },

        emitEventOK() {
            if (this.validate()) {               
                this.$emit('input', { ...this.item });
                this.$emit('ok');
            } else {
                if (!this.isValid('itemCode')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('itemCode'),"errorAutoHide"); 
                }
                if (!this.isValid('location')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('location'),"errorAutoHide"); 
                }
                if (!this.isValid('quantity')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('quantity'),"errorAutoHide"); 
                }
                if (!this.isValid('unitPrice')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('unitPrice'),"errorAutoHide"); 
                }
                if (!this.isValid('expirationDate')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('expirationDate'),"errorAutoHide"); 
                }
                if (!this.isValid('lotNo')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('lotNo'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
            }
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            
            if (type.indexOf('location') >= 0) {
                this.item.code = result.code
                this.item.location = result.code;
                this.item.locationDescription = result.description;
            } else if (type.indexOf('itemCode') >= 0) {
                this.item.itemCode = result.code.trim();
                this.item.description = result.description;

                if (result.AuxFields && result.AuxFields.length > 0) {
                    this.item.uom = result.AuxFields[0];
                    this.item.minOrder = result.AuxFields[2];
                    this.item.unitPrice = result.AuxFields[3];
                } else {
                    this.item.uom = null;
                    this.item.minOrder = null;
                    this.item.unitPrice = null;
                }
            }
        },

        changeHandler() {
            const quantity = this.item.quantity;
            const price = this.item.unitPrice;
            this.item.itemTotal = (quantity * price).toFixed(2) ?? 0;
        },

        validate() {
            const rules = {
                expirationDate: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateMsg")
                    ),
                    validationRules.date(
                        'YYYY-MM-DD',
                        this.$t("Msg.InvalidDate")
                    ),
                    validationRules.greaterThanDate(
                        Utils.getCurrentDateTime(),
                        'YYYY-MM-DD',
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateLessMsg")
                    ),
                ],
                location: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidLocationMsg")
                    ),
                ],
                itemCode: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidItemCodeMsg")
                    ),
                ],
                quantity: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.RequiredQuantityMsg")
                    ),
                    validationRules.greaterThan(0,
                        this.$t("eItemsReceivedEdit.InvalidQuantityMsg")
                    ),
                ],
                unitPrice: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidUnitPriceMsg")
                    ),
                ],
                lotNo: [
                    validationRules.required(
                        this.$t("eItemsReceivedEdit.InvalidLotNoMsg")
                    ),
                ]
            }
            
            return this.validateFields(rules, this.item);
        },

        close() {
            this.emitEventCancel();
        }
    }
}
</script>